
import { useState, useCallback } from 'react';
import { Direction } from '../types.js';

export const useSwipe = ({ onSwiped }) => {
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart([e.targetTouches[0].clientX, e.targetTouches[0].clientY]);
  };

  const handleTouchMove = (e) => {
    setTouchEnd([e.targetTouches[0].clientX, e.targetTouches[0].clientY]);
  };

  const handleTouchEnd = useCallback(() => {
    if (!touchStart || !touchEnd) return;
    const [startX, startY] = touchStart;
    const [endX, endY] = touchEnd;
    const dx = endX - startX;
    const dy = endY - startY;

    if (Math.abs(dx) > minSwipeDistance || Math.abs(dy) > minSwipeDistance) {
      if (Math.abs(dx) > Math.abs(dy)) {
        onSwiped(dx > 0 ? Direction.RIGHT : Direction.LEFT);
      } else {
        onSwiped(dy > 0 ? Direction.DOWN : Direction.UP);
      }
    }
    setTouchStart(null);
    setTouchEnd(null);
  }, [touchStart, touchEnd, onSwiped]);

  return {
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
  };
};
